import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'faceted-filter';

/**
 * Class Foo.
 */
export class FacetedFilter extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  /**
   * connectedCallback
   */
  connectedCallback() {
    this.getElements();
  }

  /**
   * getElements
   */
  getElements() {
    this.content = this.querySelector('.faceted__content');
    this.btn = this.querySelector('.filter__btn');
    this.badge = this.querySelector('unistra-badge');

    this.filtersActiveText = document.createElement('span');
    this.filtersActiveText.className = 'sr-only';
    this.filtersActiveText.textContent = this.dataset.filtersActiveText || 'filtres activés';

    this.btn.addEventListener('click', this.onClick.bind(this));
    // Delegated on the host rather than bound per-checkbox at init: Drupal
    // facets are rebuilt over AJAX when a filter is applied, replacing the
    // checkbox nodes with new ones a one-time querySelectorAll/forEach would
    // never see, silently desyncing both the tabindex handling below and the
    // badge/filters-active-text count.
    this.addEventListener('change', this.onCheckboxChange.bind(this));
    this.updateInert();

    this.onCheckboxChange();
  }

  /**
   * getCheckbox count
   * @returns {number}
   */
  get checkedCheckboxCount() {
    return this.querySelectorAll('input[type="checkbox"]:checked').length;
  }

  /**
   * onClick
   */
  onClick() {
    const willBeHidden = this.content.getAttribute('aria-hidden') === 'false';
    this.content.setAttribute('aria-hidden', String(willBeHidden));
    this.btn.setAttribute('aria-expanded', String(!willBeHidden));
    this.updateInert();
  }

  /**
   * The panel collapses via grid-template-rows: 0fr + overflow: hidden, not
   * display: none, so its checkboxes stay in the DOM and focusable unless
   * explicitly inerted while hidden. Driven by aria-hidden (rather than a
   * frozen checkbox list built once at init) so it also covers checkboxes
   * added later by Drupal's AJAX facet rebuild, and an initially-expanded
   * panel starts with the right tabindex state instead of forcing -1.
   */
  updateInert() {
    this.content.toggleAttribute('inert', this.content.getAttribute('aria-hidden') !== 'false');
  }

  /**
   * onCheckboxChange
   */
  onCheckboxChange() {
    this.badge.innerHTML = String(this.checkedCheckboxCount);
    this.badge.classList.toggle('is-hidden', this.checkedCheckboxCount === 0);

    if (this.checkedCheckboxCount > 0 && !this.filtersActiveText.isConnected) {
      this.badge.after(this.filtersActiveText);
    } else if (this.checkedCheckboxCount === 0 && this.filtersActiveText.isConnected) {
      this.filtersActiveText.remove();
    }
  }
}
